import { Suspense } from "react";
import { useParams } from "react-router-dom";
import { getTemplate } from "@/templates/registry";
import { Loader2 } from "lucide-react";

// Bare full-screen render of a template — loaded inside the demo iframe so device
// switching (iframe width) triggers real responsive breakpoints without a reload.
export default function BareTemplate() {
  const { slug } = useParams();
  const tpl = getTemplate(slug);
  if (!tpl) {
    return <div className="min-h-screen grid place-items-center text-slate-500">Template not found.</div>;
  }
  const Component = tpl.component;
  return (
    <Suspense fallback={<div className="min-h-screen grid place-items-center bg-white"><Loader2 className="animate-spin text-slate-400" size={28} /></div>}>
      <div id="tpl-root"><Component /></div>
    </Suspense>
  );
}
